// extracted by mini-css-extract-plugin
module.exports = {"patientCol":"Table_patientCol__g_hPw"};